<template>
    <footer class="site-footer">
      <div class="footer-container">
        <div class="footer-column">
          <h3>RTH Group</h3>
          <p>
            A professional recruiting and employment company specializing in connecting cleaners with quality job opportunities.
          </p>
          <div class="social-icons">
            <i class="fab fa-facebook"></i>
            <i class="fab fa-instagram"></i>
            <i class="fab fa-twitter"></i>
            <i class="fab fa-linkedin"></i>
          </div>
        </div>
  
        <div class="footer-column">
          <h4>Quick Links</h4>
          <ul>
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/jobs">Available Jobs</router-link></li>
            <li><router-link to="/apply">Application Form</router-link></li>
            <li><router-link to="/about">About Us</router-link></li>
            <li><router-link to="/contact">Contact</router-link></li>
          </ul>
        </div>
  
        <div class="footer-column">
          <h4>Resources</h4>
          <ul>
            <li><router-link to="/tips">Cleaning Tips</router-link></li>
            <li><router-link to="/training">Training Resources</router-link></li>
            <li><router-link to="/benefits">Employee Benefits</router-link></li>
            <li><router-link to="/growth">Career Growth</router-link></li>
            <li><router-link to="/faq">FAQ</router-link></li>
          </ul>
        </div>
  
        <div class="footer-column">
          <h4>Contact Us</h4>
          <ul>
            <li>📞 865-352-8700</li>
            <li>✉️ rthcleaners@rthgroupinc.com</li>
            <li>📍 1169 Wears Valley Road<br />Pigeon Forge, Tennesse 37863</li>
          </ul>
        </div>
      </div>
  
      <div class="footer-bottom">
        <p>© 2025 RTH Group. All rights reserved.</p>
      </div>
    </footer>
  </template>
<style scoped>
.site-footer {
  background-color: #222;
  color: #f1f1f1;
  padding: 3rem 1.5rem 2rem;
  font-size: 0.95rem;
  box-sizing: border-box;
  width: 100%;
  overflow-x: hidden;
}

.footer-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 2rem;
  margin-bottom: 1.5rem;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.footer-column {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  word-break: break-word;
}

.footer-column h3,
.footer-column h4 {
  color: #fff;
  margin-bottom: 0.75rem;
}

.footer-column p {
  line-height: 1.6;
  color: #ccc;
  margin: 0;
  word-wrap: break-word;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-column ul li {
  margin-bottom: 0.5rem;
  color: #ccc;
  word-break: break-word;
}

.footer-column ul li a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s;
  word-break: break-word;
  display: inline-block;
  max-width: 100%;
}

.footer-column ul li a:hover {
  color: #fff;
}

.social-icons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1rem;
  font-size: 1.25rem;
  max-width: 100%;
  overflow-wrap: break-word;
}

.social-icons i {
  flex: 0 0 auto;
  max-width: 100%;
  color: #ccc;
}

.footer-bottom {
  text-align: center;
  border-top: 1px solid #444;
  padding-top: 1rem;
  font-size: 0.9rem;
  color: #aaa;
  word-break: break-word;
}

@media (max-width: 480px) {
  .footer-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}
</style>
